// @mui
import AppDialog from '../../../components/Common/AppDialog';
// utils

// ----------------------------------------------------------------------

export default function ActivateShippingZoneModal(props) {
    return (
        <>
            <AppDialog
                open={props.open}
                close={() => { props.close() }}
                title={`${props?.isActive ? 'Deactivate' : 'Reactivate'} shipping zone?`}
                positiveTitle={`${props?.isActive ? 'Deactivate' : 'Reactivate'}`}
                positivePress={() => props.submit()}
                cancelButton={true}
                width={'40%'}
            >
                <div style={{ color: '#594A4E' }}>
                    You are about to {props?.isActive ? 'deactivate' : 'reactivate'} this shipping zone.
                    <div className='mt-2'>
                        {
                            props?.isActive ?
                                'Customers with delivery addresses in this zone will no longer be able to select shipping during checkout until the zone is activated again.'
                                : 'Customers with delivery addresses in this zone will be able to select shipping during checkout.'
                        }
                    </div>
                    {
                        props?.isActive &&
                        <div className='mt-2'>
                            This action will not affect existing orders.
                        </div>
                    }
                </div>
            </AppDialog>
        </>


    );
}